(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/router-draw.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/router-draw.js');
"use strict";


const {
  BrowserRouter,
  Route
} = ReactRouterDOM;
const {
  baseUrl
} = svs.core.data;
const RouterDraw = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(BrowserRouter, {
    basename: baseUrl
  }, React.createElement(Route
  , {
    children: _ref2 => {
      let {
        match
      } = _ref2;
      if (!match) {
        return null;
      }
      return children;
    },
    path: "/spela/:drawNumber([0-9]+)"
  }));
};
svs.challenge.RouterDraw = RouterDraw;

 })(window);